import { Analytics } from 'types/analytics';

import { Nullable } from '../../../types/utils';

const getRetrieveQuote = (state: Nullable<Analytics>) => ({
  retrieveQuote: state.retrieveQuote?.retrieveQuoteId ? 'true' : 'false',
});

const getPayMyBillPolicy = (state: Nullable<Analytics>) => {
  const { payMyBill } = state;
  if (payMyBill !== undefined && payMyBill !== null) {
    return {
      policyNumber: payMyBill.policyNumber,
      paymentAmount: payMyBill.dueAmount,
      policyType: payMyBill.policyType,
      policyStatus: payMyBill.policyStatus,
    };
  }
  return false;
};
const getAnalytics = (state: Nullable<Analytics>) => {
  if (!state) return {};
  const retrieveQuote = getRetrieveQuote(state);
  const payMyBill = getPayMyBillPolicy(state);

  if (payMyBill) {
    return {
      ...retrieveQuote,
      ...payMyBill,
    };
  }

  return {
    ...retrieveQuote,
  };
};

export default getAnalytics;
